import React, { useState, useEffect, useRef } from "react";
import styles from "./MoreTasks.module.css";

const MoreTasks = ({ isOpen, onClose, tasks, date, position, onDragStart, onCompleteDragAndDrop }) => {
  const popupRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleDragStart = (e, task) => {
    e.dataTransfer.setData("application/json", JSON.stringify(task));
    e.dataTransfer.effectAllowed = "move";
    setIsDragging(true);
    if (onDragStart) {
      onDragStart(task);
    }
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (onCompleteDragAndDrop) {
      onCompleteDragAndDrop();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      ref={popupRef}
      className={styles.popupContainer}
      style={{
        top: `${position.y}px`,
        left: `${position.x}px`,
        position: "absolute",
        opacity: isDragging ? 0.5 : 1,
        transition: "opacity 0.2s ease-in-out",
      }}
    >
      <div className={styles.popupContent}>
        <h2>Tareas del {date}</h2>
        <ul className={styles.taskList}>
          {tasks.length > 0 ? (
            tasks.map((task) => (
              <li
                key={task.id}
                className={styles.taskItem}
                draggable="true"
                onDragStart={(e) => handleDragStart(e, task)}
                onDragEnd={handleDragEnd}
              >
                <span className={styles.taskDot} style={{ backgroundColor: task.color }}></span>
                <span
                  className={styles.taskText}
                  style={{
                    textDecoration: task.Hecho === 1 ? "line-through" : "none",
                    opacity: task.Hecho === 1 ? 0.6 : 1,
                  }}
                >
                  {task.Subtarea || "Sin subtarea"}
                </span>
              </li>
            ))
          ) : (
            <p>No hay tareas para este día.</p>
          )}
        </ul>
        <button onClick={onClose} className={styles.closeButton}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default MoreTasks;
